export default __webpack_public_path__ + "static/media/hero-img.bd75b319.png";